'use client';

import { forwardRef, useState } from 'react';
import Eye from 'src/libs/components/icons/eye';
import EyeSlash from 'src/libs/components/icons/eye-slash';
import Input, { FloatingInputProps } from '.';

const PssswordInput = forwardRef<HTMLInputElement, FloatingInputProps>((props, ref) => {
    const [show, setShow] = useState<boolean>(false);

    return (
        <Input
            ref={ref}
            {...props}
            type={show ? 'text' : 'password'}
            endAdornment={
                <div onClick={() => setShow((prev) => !prev)} className='cursor-pointer'>
                    {show ? <Eye className='text-gray-400' /> : <EyeSlash className='text-gray-400' />}
                </div>
            }
        />
    );
});

PssswordInput.displayName = 'PssswordInput';

export default PssswordInput;

